function nonDisruptingError(message) {
    setTimeout(() => {
        throw new Error(message);
    }, 0);
}

export default nonDisruptingError;